import { AccountSitesSelectionComponent } from './account-sites-selection.component';

export const ACCOUNT_SITES_SELECTION_DECLARATIONS: any[] = [
  AccountSitesSelectionComponent
];

export { AccountSitesSelectionComponent };
